import type { EventRole } from "./types";

export type Action =
  | "view"
  | "edit_event_settings"
  | "edit_questions"
  | "open_close_question"
  | "switch_stage_view"
  | "pause_event"
  | "pause_rotation"
  | "trigger_ai"
  | "approve_manifesto"
  | "edit_tools"
  | "edit_streams"
  | "moderate_responses"
  | "assign_response_cluster"
  | "reset_event"
  | "export_event"
  | "delete_event"
  | "manage_cofacilitators";

const MATRIX: Record<Action, EventRole[]> = {
  view:                    ["owner", "co_admin", "co_mod"],
  edit_event_settings:     ["owner", "co_admin"],
  edit_questions:          ["owner", "co_admin"],
  open_close_question:     ["owner", "co_admin"],
  switch_stage_view:       ["owner", "co_admin"],
  pause_event:             ["owner", "co_admin", "co_mod"],
  pause_rotation:          ["owner", "co_admin", "co_mod"],
  trigger_ai:              ["owner", "co_admin", "co_mod"],
  approve_manifesto:       ["owner", "co_admin"],
  edit_tools:              ["owner", "co_admin"],
  edit_streams:            ["owner", "co_admin"],
  moderate_responses:      ["owner", "co_admin", "co_mod"],
  assign_response_cluster: ["owner", "co_admin", "co_mod"],
  reset_event:             ["owner", "co_admin"],
  export_event:            ["owner", "co_admin", "co_mod"],
  delete_event:            ["owner"],
  manage_cofacilitators:   ["owner"],
};

export function can(role: EventRole | null, action: Action): boolean {
  if (!role) return false;
  return MATRIX[action].includes(role);
}
